import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateInventory'

const crateInventory = axios.create({
  baseURL
})

interceptorsSetup(crateInventory)

export default class Inventory {
  static async getTable (inventoryQuery) {
    const result = await crateInventory.get('/' + inventoryQuery.siteId, {
      params:
      {
        start: inventoryQuery.start,
        end: inventoryQuery.end
      }
    })
    return result.data
  }
  static async createInventory (newInventory) {
    const result = await crateInventory.post('/', newInventory)
    return result.data
  }
  static async updateInventory (inventory) {
    const result = await crateInventory.post('/update', inventory)
    return result.data
  }
  static async archiveInventory (inventory) {
    const result = await crateInventory.put('/archive/' + inventory)
    return result.data
  }
}
